export enum Potential {
  base = 'base',
  potentialMeanAbsolute = 'potentialMeanAbsolute',
  potentialMeanRelative = 'potentialMeanRelative',
  potentialMinAbsolute = 'potentialMinAbsolute',
  potentialMinRelative = 'potentialMinRelative',
  potentialMinMeanAbsolute = 'potentialMinMeanAbsolute',
  potentialMinMeanRelative = 'potentialMinMeanRelative',
  purchaseGross = 'purchaseGross',
  customerGrossPrice = 'customerGrossPrice',
  purchaseNetWholesaleUnrepaired = 'purchaseNetWholesaleUnrepaired',
  purchaseNetRetailUnrepaired = 'purchaseNetRetailUnrepaired',
  purchaseNetRetailRepaired = 'purchaseNetRetailRepaired',
}
